import React, { useState } from "react";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import "./LoginPage.css";
import { FaStethoscope } from "react-icons/fa6";
import { GoLaw } from "react-icons/go";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import loginImage from "../../assets/images/login_image.jfif";
import { useNavigate } from "react-router-dom";
import FileUploadModal from "../../components/Modal/FileUploadModal";

import axios from "axios";
import { BASE_URL } from "../../constants";

const LoginPage = () => {
  const [selectedRole, setSelectedRole] = useState("lawyer");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  const toggleVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleLogin = async () => {
    try {
      const loginData = {
        email,
        password,
        role: selectedRole,
      };

      const res = await axios.post(`${BASE_URL}/login`, loginData);
      const data = res.data;

      console.log("Login response:", data);

      if (res.status === 200 && data.token && data.user) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        setUser(data.user);
        navigate("/home"); // or wherever you want to route
      } else {
        alert(data.message || "Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Something went wrong during login.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-left">
          <div className="login-left-inner">
            <h2 className="login-left-heading">Welcome to</h2>
            <h2 className="login-left-heading">Nobel Flow</h2>
            <p className="login-left-subheading">
              Please sign in to securely access your account.
            </p>
            <p className="role-selection-heading"> Please select your role:</p>
            <div className="role-selection">
              <div
                className={`role-card ${
                  selectedRole === "medical" ? "active" : ""
                }`}
                onClick={() => setSelectedRole("medical")}
              >
                <FaStethoscope
                  className={`icon ${
                    selectedRole === "medical" ? "active" : ""
                  }`}
                />
                <span>HEALTHCARE PROVIDER</span>
              </div>
              <div
                className={`role-card ${
                  selectedRole === "lawyer" ? "active" : ""
                }`}
                onClick={() => setSelectedRole("lawyer")}
              >
                <GoLaw
                  className={`icon ${
                    selectedRole === "lawyer" ? "active" : ""
                  }`}
                />
                <span>LEGAL TEAM</span>
              </div>
            </div>
            <div className="login-form">
              {email && <p>Email:</p>}
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`login-input ${email ? "filled" : ""}`}
              />
              {password && <p>Password:</p>}
              <div className="password-input-container">
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`login-input ${password ? "filled" : ""}`}
                />
                <span onClick={toggleVisibility} className="toggle-password">
                  {passwordVisible ? <AiFillEyeInvisible /> : <AiFillEye />}
                </span>
              </div>
              <div className="remember-forgot">
                <label className="remember-me">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                  />
                  Remember Me
                </label>
                <a href="#" className="forgot-password">
                  Forgot Password?
                </a>
              </div>
              <button
                className="login-button"
                onClick={handleLogin}
                type="button"
              >
                Login
              </button>
              <div className="divider">
                <span>OR</span>
              </div>
              <button
                className="login-button"
                onClick={() => setIsModalOpen(true)}
              >
                Upload using AI
              </button>
            </div>
          </div>
        </div>
        <div className="login-right">
          <img src={loginImage} alt="Login Illustration" />
        </div>
      </div>
      <FileUploadModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default LoginPage;
